import { el, enUS, et, lt, pl } from 'date-fns/locale';
import i18n from 'i18next';
import { setDefaultOptions, parse as parseDate, format as formatDate, isValid } from 'date-fns';
import type { Locale } from 'date-fns';

import dateFnsGenerateConfig from '@rc-component/picker/lib/generate/dateFns';
import { DatePicker as AntdDatePicker } from 'antd';

const locales: Record<string, Locale> = { en: enUS, pl, el, et, lt };

setDefaultOptions({ locale: locales[i18n.language] || enUS });

const getLocale = (locale: string): Locale =>
  locales[locale] || locales[locale.replace(/_/g, '')] || locales[locale.replace(/_.*$/g, '')];

const localeParse = (format: string) =>
  format
    .replace(/Y/g, 'y')
    .replace(/D/g, 'd')
    .replace(/gggg/, 'yyyy')
    .replace(/g/g, 'G')
    .replace(/([Ww])o/g, 'wo');

const parse = (text: string, format: string, locale: string) =>
  parseDate(text, localeParse(format), new Date(), { locale: getLocale(locale) });

const isStrictValidDate = (text: string, format: string, locale: string) => {
  const date = parse(text, format, locale);
  if (!isValid(date)) return false;
  return text === formatDate(date, format, { locale: getLocale(locale) });
};

const DatePicker = AntdDatePicker.generatePicker<Date>({
  ...dateFnsGenerateConfig,
  locale: {
    ...dateFnsGenerateConfig.locale,
    parse: (locale: string, text: string, formats: string[]) => {
      for (let i = 0; i < formats.length; i += 1) {
        const f = localeParse(formats[i]);
        if (isStrictValidDate(text, f, locale)) return parse(text, f, locale);
      }
      return null;
    },
  },
});

export default DatePicker;
